export default "__VITE_ASSET__BkntzFvl__"